<template>
<div class="chapter">
<div class="inner_page">
<p class="center">This Book is Dedicated</p>
<p class="center">To My Granddaughter</p>
<p class="center">OZMA BAUM</p><a id="page_ii"></a><a id="page_iii">
<div class="img_container">
<img alt="Image" src="Book1/images/Baum-LostPrincess-scan005.jpg"/>
</div>
<div class="img_container">
<img alt="Image" src="Book1/images/Baum-LostPrincess-scan006.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm1.vue?4788cbbf